// Wall-clock timestamps for the transcript. If the meeting has a
// recorded_at set, "0:14 from audio start" renders as "11:14:13"
// (when recorded_at is 11:14:00). Falls back to relative MM:SS
// when recorded_at is null.

export function formatWallClock(
  recordedAt: string | null,
  audioOffsetMs: number,
): string {
  if (!recordedAt) return formatRelative(audioOffsetMs);
  const base = new Date(recordedAt);
  const absolute = new Date(base.getTime() + audioOffsetMs);
  const hh = absolute.getHours().toString().padStart(2, "0");
  const mm = absolute.getMinutes().toString().padStart(2, "0");
  const ss = absolute.getSeconds().toString().padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}

export function formatRelative(ms: number): string {
  const s = Math.floor(ms / 1000);
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${sec.toString().padStart(2, "0")}`;
}

// English short calendar date for the meeting, e.g. "Tue, 7 Jun 2026".
// Shown next to the moving playhead time in the audio player so a wall-clock
// time is anchored to a day. Empty string when no recorded_at is set. Uses
// the browser's local timezone, matching formatWallClock above. English (not
// Hebrew) per Ilan: the system/working language is English; Hebrew is the
// transcript output, not the chrome.
export function formatMeetingDate(recordedAt: string | null): string {
  if (!recordedAt) return "";
  const d = new Date(recordedAt);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

